import {
  BookPageDimensions,
  type BookSize,
  COVER_WRAP_SIZE,
} from '@mixtiles/web-backend-shared'
import { type AiGeneratedCover } from 'components/PhotoBook/PhotoBookProvider/PhotoBook.types'
import { getAiCoverStyle } from 'features/photoBookAiCovers/coverStyles.consts'
import { type Rect } from 'utils/cropUtils.types'
import { type ThumbCrop } from 'stores/cartStore/CartItem'

// Print draws the image as one square over the front panel and its wrap, anchored to the outer
// edge and centred vertically; this is the front panel's part of that square.
export function getAiCoverFrontCrop(bookSize: BookSize): Rect {
  const { pageWidth, pageHeight } = BookPageDimensions[bookSize]
  const side = Math.max(
    pageWidth + COVER_WRAP_SIZE,
    pageHeight + 2 * COVER_WRAP_SIZE
  )
  return {
    x: (side - COVER_WRAP_SIZE - pageWidth) / side,
    y: (side - pageHeight) / 2 / side,
    width: pageWidth / side,
    height: pageHeight / side,
  }
}

export function getAiCoverDisplayCrop(
  aiCover: AiGeneratedCover,
  bookSize: BookSize
): Rect | null {
  return getAiCoverStyle(aiCover).isPrintedWithWrapBand
    ? getAiCoverFrontCrop(bookSize)
    : null
}

export function getThumbCropFromRect({ x, y, width, height }: Rect): ThumbCrop {
  return { xRatio: x, yRatio: y, widthRatio: width, heightRatio: height }
}
